import gql from 'graphql-tag';

export const FETCH_SERVICES = gql`
  query {
    appointmentServices {
      serviceId
      name
      # description
      # conversationTypes: [ConversationType]
      # config: ServiceConfig
      # providingUnit: [OrgNodeListItem]
    }
  }
`;
